import { render, staticRenderFns } from "./SupportSection.vue?vue&type=template&id=a524d85a"
import script from "./SupportSection.vue?vue&type=script&lang=js"
export * from "./SupportSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports